// @ts-nocheck
const faqModule = faqModule || (() => {

  const classNamePrefix = "fm-o-faq"
  const status = {
    isInitialized: false
  }

  const setUp = () => {
    const elements = document.querySelectorAll(`.${classNamePrefix}`)
    if (elements.length === 0) return
    elements.forEach(el => {
      const entries = el.querySelectorAll(`.${classNamePrefix}__entry`)
      entries.forEach(entry => {
        entry.addEventListener("toggle", clickHandler)
      })
    })
  }

  const clickHandler = (e) => {
    const target = e.currentTarget;
    if (target.hasAttribute("open")) return

    target.classList.toggle("fm-o-faq__entry--closing")
    setTimeout(() => {
      target.classList.toggle("fm-o-faq__entry--closing")
    }, 150)

  }

  const init = () => {
    if (status.isInitialized) return
    setUp()
    status.isInitialized = true
  }

  return {
    init
  }
})()

window.addEventListener('load', faqModule.init)